import { Button, ButtonColors } from '@chiroup/components/Button';
import { FieldValidators } from '@chiroup/core/constants/DatabaseFeatureCommon';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import { ErrorResponse } from '@chiroup/core/types/ErrorResponse.type';
import { User } from '@chiroup/core/types/User.type';
import { useForm } from '@chiroup/hooks/useForm';
import React from 'react';
import { UseMutateFunction } from 'react-query';
import SlideOver from '../../common/SlideOver';
import UserGeneralFormElements from './UserGeneralFormElements';

type Props = {
  editSlideOverState: OpenClosedStates;
  updateSlideOverState: (val: OpenClosedStates) => void;
  defaultValues: Partial<User>;
  update: UseMutateFunction<Partial<User>, ErrorResponse, Partial<User>, unknown>;
  isUpdating: boolean;
};

const validation = {
  fname: {
    required: {
      message: 'First name is required.',
    },
  },
  lname: {
    required: {
      message: 'Last name is required.',
    },
  },
  phone: FieldValidators.phone(),
};

const UserGeneralEditPanel: React.FC<Props> = ({
  editSlideOverState,
  updateSlideOverState,
  defaultValues,
  update,
  isUpdating,
}) => {
  const { value, registerSubmit, isDirty, errors, onChange, patchValue } = useForm<User>(
    defaultValues,
    validation
  );

  const onSubmit = async (patient: Partial<User>) => {
    if (defaultValues.ID) {
      patient.ID = defaultValues.ID;
    }

    update(patient);

    return patient;
  };

  return (
    <SlideOver
      title="Edit user"
      slideOverState={editSlideOverState}
      updateSlideOverState={updateSlideOverState}
      buttons={
        <>
          <Button
            text="Close"
            onClick={() => updateSlideOverState(OpenClosedStates.Closed)}
            color={ButtonColors.plain}
          />
          <Button
            text="Save"
            disabled={!isDirty || isUpdating}
            loading={isUpdating}
            onClick={registerSubmit(onSubmit, {})}
          />
        </>
      }
    >
      <form>
        <div className="py-6 space-y-6 sm:py-0 sm:space-y-0 sm:divide-y sm:divide-gray-300">
          <div className="space-y-1 sm:space-y-0 sm:grid sm:grid-cols-4 sm:gap-4">
            <UserGeneralFormElements
              fieldErrors={errors.fieldErrors}
              value={value}
              onChange={onChange}
              patchValue={patchValue}
            />
          </div>
        </div>
      </form>
    </SlideOver>
  );
};

export default UserGeneralEditPanel;
